import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductCategoryService, SubCategory } from 'src/app/core/product-category.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';

@Component({
  selector: 'app-product-subcategory-delete-dialog',
  templateUrl: './product-subcategory-delete-dialog.component.html',
  styleUrls: ['./product-subcategory-delete-dialog.component.scss'],
})
export class ProductSubcategoryDeleteDialogComponent {
  product_category_id?: string;
  subcategory?: SubCategory;
  is_delete_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<ProductSubcategoryDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private product_category_service: ProductCategoryService,
    private error_service: ErrorService,
  ) {
    this.product_category_id = data.product_category_id;
    this.subcategory = data.subcategory;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onDeleteClick(): void {
    if (this.product_category_id && this.subcategory?.sub_category_id) {
      this.deleteSubcategory(this.product_category_id, this.subcategory.sub_category_id);
    }
  }

  deleteSubcategory(product_category_id: string, sub_category_id: string): void {
    this.is_delete_running = true;
    this.product_category_service.deleteSubCategory(product_category_id, sub_category_id).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_delete_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_delete_running = false;
      },
    });
  }
}
